import { MensajesGenericos_EN } from './Genericos/DiccionarioMensajesGenericos_EN';
import { DiccionarioAcademico_EN } from './DiccionariosAreas/DiccionarioAcademico_EN';
import { DiccionarioSeguridad_EN } from './DiccionariosAreas/DiccionarioSeguridad_EN';
import { DiccionarioLogin_EN } from './DiccionariosAreas/DiccionarioLogin_EN';
import { DiccionarioCajas_EN } from './DiccionariosAreas/DiccionarioCajas_EN';

const DiccionarioInterno = [
    {
        'codigo': 'ErrorValidUUID',
        'mensaje': 'Invalid validation token.'
    },
    {
        'codigo': 'ErrorValidFormatUUID',
        'mensaje': 'Invalid validation token format.'
    },
    {
        'codigo': 'ErrorRequiredEmail',
        'mensaje': 'There is no email associated with your user account. Contact administration.'
    },
    {
        'codigo': 'SussesEmailSend',
        'mensaje': 'Verification code successfully sent to your email account.'
    },
    {
        'codigo': 'ErrorExistsClient',
        'mensaje': 'Another student with that identification already exists.'
    },
    {
        'codigo': 'DuplicateCustomerEmailNI',
        'mensaje': 'The entered email address is not available. Contact administration.'
    }
];

export const DiccionarioMensajes_EN = [...DiccionarioInterno, ...MensajesGenericos_EN, ...DiccionarioLogin_EN,
    ...DiccionarioAcademico_EN, ...DiccionarioSeguridad_EN, ...DiccionarioCajas_EN];